import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const NSWFARImage = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "nsw-far-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 300, maxHeight: 352) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.placeholderImage.childImageSharp.fluid}
      alt="Fire-and-Rescue-logo"
    />
  )
}

export default NSWFARImage
